import { inject, Navigator } from "fw";
import { dispatch } from "fw-state";

import { ActivityStore, StopActivityTrackerAction } from "state/activity";

import { Manager } from "network/manager";
import { dateDiff } from "helpers/date-diff";
import { LogoutAction, RefreshTokenAction } from "../state/actions";

@inject
export class ActivityAlert {
    private intervalCountdown: ReturnType<typeof setInterval> | null = null;
    private duration: number = 0;
    private currentPageTitle: string = "";
    private tokenExpireDate: string = "";

    constructor(
        private store: ActivityStore,
        private nav: Navigator,
        private network: Manager
    ) {}

    private initCountdown(): void {
        this.currentPageTitle = document.title;
        this.tokenExpireDate = this.network.getTokenExpDate();
        this.duration = dateDiff(new Date(), this.tokenExpireDate, "s") || 0;
        this.intervalCountdown = setInterval(() => this.countdown(), 1000);
        console.log(`Started logout countdown at ${new Date()}.`);
    }

    private clearCountdown(): void {
        clearInterval(this.intervalCountdown);
        this.duration = 0;
    }

    private get formattedDuration() {
        const mm = Math.floor(this.duration / 60);
        const s = this.duration % 60;
        const ss = s < 10 ? "0" + s : s;
        return `${mm}:${ss}`;
    }

    private countdown(): void {
        this.duration = dateDiff(new Date(), this.tokenExpireDate, "s") || 0;
        document.title = `${this.formattedDuration} until logout - Admissions by Liaison`;
        if (this.duration <= 0) {
            console.log(`Logged out at ${new Date()} because the logout countdown elapsed.`);
            this.closeAndLogout("You were automatically logged out due to inactivity.");
        }
    }

    private setDefaultTitle(): void {
        document.title = this.currentPageTitle;
    }

    public closeAndLogout(reason: string = null): void {
        this.clearCountdown();
        this.setDefaultTitle();
        dispatch(new StopActivityTrackerAction());
        dispatch(new LogoutAction(reason));
    }

    public refresh() {
        this.clearCountdown();
        dispatch(new RefreshTokenAction());

        this.setDefaultTitle();
    }

    get isActive(): boolean {
        if (this.store?.state?.showActivityAlert) this.initCountdown();
        else this.clearCountdown();
        return this.store?.state?.showActivityAlert;
    }
}
